import { localizeWithPath } from '../../../../nls.js';
import { languagesExtPoint } from '../../../services/language/common/languageService.js';
const _moduleId = "vs/workbench/contrib/codeActions/common/documentationExtensionPoint";
var DocumentationExtensionPointFields;
( ((function(DocumentationExtensionPointFields) {
    DocumentationExtensionPointFields["when"] = "when";
    DocumentationExtensionPointFields["title"] = "title";
    DocumentationExtensionPointFields["command"] = "command";
})(
    DocumentationExtensionPointFields || (DocumentationExtensionPointFields = {})
)));
const documentationExtensionPointSchema = ( (Object.freeze({
    type: 'object',
    description: ( localizeWithPath(_moduleId, 0, "Contributed documentation.")),
    properties: {
        'refactoring': {
            type: 'array',
            description: ( localizeWithPath(_moduleId, 1, "Contributed documentation for refactorings.")),
            items: {
                type: 'object',
                description: ( localizeWithPath(_moduleId, 2, "Contributed documentation for refactoring.")),
                required: [
                    DocumentationExtensionPointFields.title,
                    DocumentationExtensionPointFields.when,
                    DocumentationExtensionPointFields.command
                ],
                properties: {
                    [DocumentationExtensionPointFields.title]: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 3, "Label for the documentation used in the UI.")),
                    },
                    [DocumentationExtensionPointFields.when]: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 4, "When clause.")),
                    },
                    [DocumentationExtensionPointFields.command]: {
                        type: 'string',
                        description: ( localizeWithPath(_moduleId, 5, "Command executed.")),
                    },
                },
            }
        }
    }
})));
const documentationExtensionPointDescriptor = {
    extensionPoint: 'documentation',
    deps: [languagesExtPoint],
    jsonSchema: documentationExtensionPointSchema
};
export { documentationExtensionPointDescriptor };
